var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup__wrap"},[_c('div',{staticClass:"popup__header"},[_c('div',{staticClass:"popup__image mr-2"}),_vm._v(" "),_c('div',{staticClass:"popup__title"},[_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"popup__message"},[_vm._v("\n        "+_vm._s(_vm.description)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ff0c2d8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-up/ErrorDownload.vue
// module id = null
// module chunks = 